import {State, Action, Selector, StateContext} from '@ngxs/store';
import {GetAlerts, ResolveAlert} from './alert.actions';
import {AlertService} from '@shared/service/alert/alert.service';
import {LoggerService} from '@app/service/logger/logger.service';
import {ToastService} from '@app/service/util/toast.service';
import {Injectable} from '@angular/core';
import {Alert} from '@shared/interfaces';
import {DataSnapshot} from '@angular/fire/compat/database/interfaces';

export interface AlertStateModel {
  alerts: Partial<Alert>[];
}

@State<AlertStateModel>({
  name: 'alert',
  defaults: {
    alerts: []
  }
})
@Injectable()
export class AlertState {
  constructor(private alertService: AlertService, private logger: LoggerService, private toast: ToastService) {
  }

  @Selector()
  static getAlertData(state: AlertStateModel) {
    return state.alerts;
  }

  @Action(ResolveAlert)
  resolveAlert({getState, patchState}: StateContext<AlertStateModel>, {payload}: ResolveAlert) {
    return this.alertService.resolveAlert(payload.alertId)
      .catch(err => {
        return this.toast.error('An error occurred while trying to resolve alert', err);
      });
  }


  @Action(GetAlerts)
  getAlertsData({getState, patchState, dispatch}: StateContext<AlertStateModel>) {
    return this.alertService.getAlerts((snapshot: DataSnapshot) => {
      if (snapshot.exists()) {
        const alertData = snapshot.val();
        const alertId = snapshot.key;

        if (alertData.isRead) {
          return;
        }

        this.toast.response(alertData.level, alertData.message, alertData.description, 0);
        const alerts = Object.assign([], getState().alerts);
        alerts.push({
          ...alertData,
          alertId
        });

        patchState({
          alerts
        });
        dispatch(new ResolveAlert({
          alertId
        }));
      }
    });
  }
}
